import { render } from "./ValidationErrors.vue?vue&type=template&id=7f46a6ca"
import script from "./ValidationErrors.vue?vue&type=script&lang=js"
export * from "./ValidationErrors.vue?vue&type=script&lang=js"
script.render = render

export default script